import { useGlobalUser } from "@/stores/globalUser";
import { useMate } from "@/stores/mate";

export const useScopedMateId = <T>(
  func: () => Promise<T>,
  mateId?: number
): (() => Promise<T>) => {
  return async () => {
    const globalUser = useGlobalUser();
    const mateStore = useMate();
    globalUser.scopedCurrentMateId = mateId ?? mateStore.userMate?.id ?? 0;
    const result = await func();
    globalUser.scopedCurrentMateId = 0;
    return result;
  };
};
